import api from './axiosInstance';

export const registerUser = (data) => api.post('/auth/register', data);
export const loginUser = (data) => api.post('/auth/login', data);
export const logoutUser = () => api.post('/auth/logout');
export const verifyEmailToken = (token, id) => api.get(`/auth/verify-email?token=${token}&id=${id}`);
export const forgotPassword = (email) => api.post('/auth/forgot-password', { email });
export const resetPassword = (token, id, password) => 
  api.post(`/auth/reset-password?token=${token}&id=${id}`, { password });
export const getCurrentUser = () => api.get('/auth/me');
export const refreshAccessToken = () => api.get('/auth/refresh');
